import React from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'

const ConfirmDialog = props => {
  return (
    <Dialog
      open={props.open}
      keepMounted
      onClose={props.onCancel}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description">
      <DialogTitle>{props.title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{props.children}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onCancel}>{props.cancelText || 'Cancelar'}</Button>
        <Button onClick={props.onOk} color="primary">
          {props.okText || 'Aceptar'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog



// WEBPACK FOOTER //
// ./src/components/ConfirmDialog.js